import { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { node, bool } from 'prop-types'
import { Popper } from '@mui/material'
import { sx } from 'utils'

const BasePopper = forwardRef(function BasePopper(props, ref) {
  const { children, webComponentFix, ...popperProps } = props

  const [popperAnchorElement, setPopperAnchorElement] = useState(null)
  const popperOpen = Boolean(popperAnchorElement)

  useImperativeHandle(ref, () => ({
    open,
    close
  }))

  function open(event) {
    setPopperAnchorElement(event.currentTarget)
  }

  function close() {
    setPopperAnchorElement(null)
  }

  return (
    <Popper
      anchorEl={popperAnchorElement}
      open={popperOpen}
      {...popperProps}
      {...(webComponentFix && {
        popperOptions: {
          modifiers: [{ name: 'flip', enabled: false }]
        },
        ...sx(popperProps, { zIndex: 1 })
      })}
    >
      {children}
    </Popper>
  )
})

BasePopper.propTypes = {
  children: node.isRequired,
  webComponentFix: bool,
}

// Hook comodo che fornisce tutto quello che serve per usare il popper
function usePopper() {
  const popperRef = useRef()
  const openPopper = event => popperRef.current?.open(event)
  const closePopper = () => popperRef.current?.close()

  return {
    popperRef,
    openPopper,
    closePopper
  }
}

export {
  BasePopper,
  usePopper
}